
import './App.css';
import Frame from './Frame/Frame';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './firebase/AuthContext';
import { configureFirebase } from './firebase/firebaseConfig';

// 実運用ではどこか起動前の地点 (index.js など) で環境に応じた設定を注入
// 例) configureFirebase(window.runtimeFirebaseConfig)
// ここでは (環境変数フォールバックを使う場合) 何も呼ばなくても良い
// configureFirebase({
//   apiKey: 'YOUR_KEY',
//   authDomain: 'YOUR_DOMAIN',
//   projectId: 'YOUR_PROJECT',
//   storageBucket: 'YOUR_BUCKET',
//   messagingSenderId: 'YOUR_SENDER_ID',
//   appId: 'YOUR_APP_ID'
// });
import AppRouter from './Router/AppRouter';

function App() {
  const title = "My App";
  const titleColor = "blue";
  const sidebarWidth = "260px";
  const collapsedSidebarWidth = "80px"; // 折りたたみ時の幅を調整
  const headerHeight = "64px";
  const headerPadding = "16px";
  const useSidebarToggle = true;
  const mainBackground = "white"; // Main領域の背景色
  return (
    <BrowserRouter>
      <AuthProvider>
        <Frame
          headerComponent={true}
          title={title}
          titleColor={titleColor}
          sidebarWidth={sidebarWidth}
          collapsedSidebarWidth={collapsedSidebarWidth}
          headerHeight={headerHeight}
          headerPadding={headerPadding}
          useSidebarToggle={useSidebarToggle}
          mainBackground={mainBackground}
        >
          <AppRouter />
        </Frame>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
